import Marquee from "react-fast-marquee";

/**
 * Slow editorial marquee — outlined Bodoni text repeating the brand ethos.
 * Adds rhythm between chapters and reinforces the luxury cadence.
 */
export default function EditorialMarquee({
    text = "Landmarks · Legacies · Craft · Trust · Bangalore",
    speed = 30,
    outlined = true,
}) {
    const items = new Array(6).fill(text);
    return (
        <section
            className="relative bg-[#0b0b0b] py-10 md:py-16 border-y border-[rgba(212,175,55,0.18)] overflow-hidden"
            data-testid="marquee-section"
        >
            <div className="marquee-fade">
                <Marquee gradient={false} speed={speed} pauseOnHover={false}>
                    {items.map((t, i) => (
                        <span
                            key={i}
                            className={`font-display italic text-[12vw] md:text-[8vw] leading-none tracking-tighter mx-10 ${
                                outlined ? "text-outline-gold" : "text-[#E2C56D]"
                            }`}
                        >
                            {t}
                            <span className="mx-8 text-[#C89B3C]/60">◆</span>
                        </span>
                    ))}
                </Marquee>
            </div>
        </section>
    );
}
